<template>
	<div class="wrapper">
		<img class="bgImg" src="../images/img/bgcimg.jpg" />
		<div class="header">
			<van-nav-bar class="nav-bar">
				<template #right>
					<van-icon name="service" @click="$router.push({path:`/ServiceOnline`})" color="#fff"
						style="padding-right: 14px;" />
					<van-icon name="setting-o" @click="$router.push({path:'/Setting'});" color="#fff" />
				</template>
			</van-nav-bar>
			<div class="user-wrapper">
				<van-image width="70" height="70" round @click="$router.push({path:'/Infomation'})"
					:src="userInfo.avatar">
					<template v-slot:loading>
						<van-loading type="spinner" />
					</template>
				</van-image>

				<div class="login-content">
					<div class="login-btn">
						<div>
							{{userInfo.username}}
						</div>
						<van-image width="70" :src="userInfo.level_image" @click="$router.push({path:'/vip'})">
							<template v-slot:loading>
								<van-loading type="spinner" />
							</template>
						</van-image>
					</div>
					<van-progress :percentage="50" pivot-text=""
						color="linear-gradient(to right, rgba(249, 5, 229, 0.5), #e6c3a1)" stroke-width="10"
						style="width: 70%;" />
					<div style="display: flex;align-items: center;padding-top: 10px;align-items: flex-end;color:#fff;">
						<div>{{$t('textS6')}}：</div>
						<div>{{userInfo.credit}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="finance">
				<!-- <div class="finance-item" @click="$router.push({path:'/Recharge'});">
					<van-icon class="icon" name="peer-pay" />
					<span class="text">{{$t("other.recharge")}}</span>
				</div> -->

				<div class="finance-item" @click="withdraw">
					<van-icon class="icon" name="idcard" />
					<span class="text">{{$t("textS9")}}</span>
				</div>
			</div>

			<div class="wallet">
				<div class="part">
					<p class="partItem">{{$t("other.my_wallet")}}</p>
					<span class="font-gray" @click="$router.push({path:'/Moneylog'});">{{$t("other.detail")}}</span>
					<van-icon name="arrow" color="#868686" />
				</div>
				<div class="part" style="padding-top: 30px;">
					<p class="balance">{{ userInfo.user_money }}</p>
					<span class="font-gray">{{$currency}}</span>
					<div class="refresh-btn" @click="getUserInfo()"><van-icon name="replay" /></div>
				</div>
			</div>

			<div class="menu">
				<div class="menu-item" @click="$router.push({path:`${item.url}`});" v-for="(item,index) in list"
					:key="index">
					<img :src="require(`@/img/${item.icon}`)" alt="" class="menu-item-icon" v-if="item.icon">
					<img :src="require(`@/img/icon${index}.svg`)" alt="" class="menu-item-icon" v-else>
					<div class="menu-item-label">{{$t(item.name)}}</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		Dialog
	} from 'vant'
	export default {
		data() {
			return {
				userInfo: {},
				list: [{
						name: 'other.account_info',
						url: '/Personalreport',
						icon: ''
					},
					{
						name: 'other.recharge_history',
						url: '/records',
						icon: ''
					},

					{
						name: 'other.withdraw_records',
						url: '/WithdrawRecord',
						icon: 'icon2.png'
					},

					{
						name: 'other.personal_info',
						url: '/Infomation',
						icon: ''
					},
					{
						name: 'other.notifications',
						url: '/Notice',
						icon: ''
					},
					{
						name: 'textS5',
						url: '/ServiceOnline',
						icon: ''
					}
				]
			};
		},
		created() {
			if (localStorage.getItem('token')) {
				this.getUserInfo();
			} else {
				this.userInfo.username = this.$t("setting.log_reg");
				this.userInfo.ip = this.$t("setting.more_service");
			}
		},
		methods: {
			withdraw() {
				console.log(this.userInfo.bankinfo.account)
				if (!this.userInfo.bankinfo.account) {
					Dialog.confirm({
							message: this.$t('bind.bank'),
							confirmButtonText: this.$t('setting.ok'),
							cancelButtonText: this.$t('setting.cancel')
						})
						.then(() => {
							this.$router.push({
								path: '/Setbank'
							});
						})
					return
				}
				this.$router.push({
					path: '/withdraw'
				});
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 1) {
						this.userInfo = res.data;
						console.log(res.data, '123456');
					} else {
						this.$toast(res.msg);
					}
				})
			},

		},

	};
</script>

<style lang='less' scoped>
	.wrapper {
		min-height: 100vh;
		background-color: #f2f2f5;

		.bgImg {
			position: absolute;
			top: 0;
			right: 0;
			object-fit: cover;
			width: 100%;
			height: 400px;
		}

		.header {
			position: relative;
			top: 0;
			right: 0;
			z-index: 2;
			background: linear-gradient(0deg, rgba(249, 5, 229, 0.5), rgba(249, 5, 229, 0.5), rgba(230, 195, 161, 0.5));
			height: 400px;

			.nav-bar {
				padding-top: 20px;
				padding-right: 20px;
				background: content-box;
			}

			.user-wrapper {
				display: flex;
				align-items: center;
				margin: 0px 40px;
				/* margin-top: 40px; */


				.login-content {
					flex: 1;
					margin-left: 30px;
					flex-direction: column;

					.login-btn {
						margin-bottom: 10px;
						font-size: 40px;
						color: #fff;
						display: flex;
						align-items: center;
					}
				}

			}
		}

		.content {
			position: relative;
			z-index: 3;
			padding: 10px 30px 30px;

			.finance {
				position: absolute;
				display: flex;
				align-items: center;
				top: -55px;
				left: 30px;
				right: 30px;
				height: 120px;
				background-color: #fff;
				border-radius: 15px;
				box-shadow: 0 1.5px 1px 0 #e4e4e7;

				.line {
					width: 3px;
					height: 40px;
					background-color: #ccc;
				}

				.finance-item {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100%;

					.text {
						margin-left: 30px;
						font-size: 30px;
						color: #000;
						font-weight: 500;
					}

					.icon {
						font-size: 50px;
					}
				}
			}

			.menu {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				background-color: #fff;
				border-radius: 15px;
				box-shadow: 0 1.5px 1px 0 #e4e4e7;
				margin-top: 30px;
				padding: 20px;
				justify-content: space-between;

				.menu-item {
					display: flex;
					align-items: center;
					padding: 20px 0;
					width: 47%;

					.menu-item-label {
						color: #868686;
						font-size: 30px;
					}

					.menu-item-icon {
						margin: 25px;
						width: 60px;
						height: 60px;
						-o-object-fit: contain;
						object-fit: contain;
					}
				}
			}

			.wallet {
				margin-top: 80px;
				padding: 50px 30px;
				background-color: #fff;
				border-radius: 15px;
				box-shadow: 0 1.5px 1px 0 #e4e4e7;

				.part {
					display: flex;
					align-items: center;

					.partItem {
						flex: 1;
					}

					.balance {
						flex: 1;
						font-size: 50px;
						font-weight: 700;
						color: #f905e5;
					}

					.font-gray {
						color: #868686;
						font-size: 28px;
					}

					.refresh-btn {
						margin-left: 20px;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 46px;
						height: 46px;
						font-size: 30px;
						border-radius: 50%;
						color: #ffffff;
						background-color: #e6c3a1;
					}
				}

			}
		}

	}
</style>